import React, { Component, Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { FormValidation, axios } from '../lib';

@inject('AuthenticationStore') @observer
export default class NovaSenha extends Component {
	constructor(props) {
    super(props);
    this.state = {
      sending: false,
      canSubmit: false,
      errorMessage: "",
			successMessage: "",
			hashChecked: false,
			hashCheckedError: false,
      form: this.initialFormValues
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  get initialFormValues() {
    return {
			password: { validation: 'minLength', length: 6, value: '' },
			password_confirmation: { validation: 'confirmation', value: '' }
		};
  };

  onChangeFieldValue(field, newValue, otherValue = null) {
    this.setState(({ canSubmit, form }) => {
      return FormValidation(this.state.form, field, newValue, otherValue);
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ canSubmit: false, sending: true, errorMessage: null, successMessage: null });

    const { password } = this.state.form;
		const { match: { params } } = this.props;
    axios.patch(`auth/recover_password/${params.hash}`, { password: password.value })
			.then((result) => {
				this.setState({
					form: this.initialFormValues,
					sending: false,
					successMessage: 'Você já pode fazer o login utilizando a nova senha'
				});
			})
		.catch((error) => {
			let errorMessage = 'Desculpe, algo deu errado. Tente novamente mais tarde.'
			
			if (error.response.status !== 500) {
				if (error.response.data.message) {
					errorMessage = error.response.data.message
				}
			}

			this.setState({ canSubmit: true, sending: false, errorMessage })
		});
  }

	componentWillMount() {
		const { match: { params } } = this.props;
		axios.get(`auth/recover_password/${params.hash}/edit`)
			.then((result) => {
				this.setState({ hashChecked: true });
			})
			.catch((error) => {
				this.setState({
					hashChecked: true,
					hashCheckedError: true,
					errorMessage: 'O token de recuperação de senha informado é inválido ou expirou'
				});
			});
	}

	render() {
		const { form, canSubmit, sending, successMessage, errorMessage, hashChecked, hashCheckedError } = this.state;
		return (
			<div className="Login-Content">
		    <div className="Img-Wrapper"><img src={require("../img/Home/Banner-Login.jpg")}/></div>

				<div className="Block">
				{ hashChecked &&
					<form onSubmit={this.handleSubmit}>
						<img src={require("../img/logo.svg")}/>
			      <h5>Guia de Branding</h5>

							{ !hashCheckedError &&
							<Fragment>
								<p> Quase lá! </p>
								<p> Digite uma nova senha para concluir o seu acesso ao Guia de Branding da Brasal.</p>
				        <div>
									<input
										placeholder="Digite a nova senha"
										type="password"
										name="password"
										value={form.password.value}
										onChange={(ev) => this.onChangeFieldValue('password', ev.target.value)} />
										<span> Digite a nova senha </span>
								</div>

								<div>
									<input
										placeholder="Confirme a nova senha"
										type="password"
										name="password_confirmation"
										value={form.password_confirmation.value}
										onChange={(ev) => this.onChangeFieldValue('password_confirmation', ev.target.value, form.password.value)} />
										<span> Confirme a nova senha </span>
								</div>

								<input
			            type="submit"
			            disabled={!canSubmit}
			            className={!canSubmit ? 'disabled' : 'enabled'}
			            value={ sending ? 'Aguarde...' : 'Enviar' } />
							</Fragment>
							}

							{ successMessage && <h6 className="successMessage">{successMessage}</h6> }
							{ errorMessage && <h6 className="errorMessage noForm">{errorMessage}</h6> }
		        <small> <NavLink to="/login">Login</NavLink> </small>
		      </form>
					}
		    </div>

			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/NovaSenha.js